import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/** Подвал (`footer` макета). */
export function Footer() {
  const { t } = useTranslation('landing');
  return (
    <footer>
      <div className="wrap">
        <span>{t('footer.copyright')}</span>
        <span>
          {t('footer.accrualNote')} · {t('footer.promoNote')} ·{' '}
          <Link to="/rules" data-rules="" style={{ color: 'inherit' }}>
            {t('footer.rules')}
          </Link>
        </span>
      </div>
    </footer>
  );
}
